module.exports = __webpack_public_path__ + "img/5-2.f3514804.svg";